// extracted by mini-css-extract-plugin
export var equalColumn = "_fw-0";